import { IMediaType } from './mediaType'
import { IInitAction } from './init'

// Action types
export enum types {
  GET_MEDIA_TYPES__STARTED = 'GET_MEDIA_TYPES__STARTED',
  GET_MEDIA_TYPES__SUCCESS = 'GET_MEDIA_TYPES__SUCCESS',
  GET_MEDIA_TYPES__FAILURE = 'GET_MEDIA_TYPES__FAILURE',
  UPDATE_MEDIA_TYPES = 'UPDATE_MEDIA_TYPES',
}

export interface IGetMediaTypesAction {
  type: types.GET_MEDIA_TYPES__STARTED
}

export interface IGetMediaTypesSuccessAction {
  type: types.GET_MEDIA_TYPES__SUCCESS
  list: IMediaType[]
}

export interface IFailureAction {
  type: types.GET_MEDIA_TYPES__FAILURE
  message: string
}

export interface IUpdateMediaTypesAction {
  type: types.UPDATE_MEDIA_TYPES
  list: IMediaType[]
}

export type MediaTypesType =
  | IGetMediaTypesAction
  | IGetMediaTypesSuccessAction
  | IUpdateMediaTypesAction
  | IFailureAction
  | IInitAction

// Reducer types
export interface IMediaTypes {
  isLoading: boolean
  list: IMediaType[]
}
